module.exports = __webpack_public_path__ + "static/media/mobile-hero.ea891e18.jpg";